/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  ERC721EqualVestingStream,
  ERC721EqualVestingStreamInterface,
} from "../ERC721EqualVestingStream";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "ticketToken",
            type: "address",
          },
          {
            internalType: "uint64",
            name: "lockedUntilTimestamp",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "startTimestamp",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "durationSeconds",
            type: "uint64",
          },
          {
            internalType: "uint256",
            name: "totalTickets",
            type: "uint256",
          },
          {
            internalType: "uint64",
            name: "claimLockedUntil",
            type: "uint64",
          },
        ],
        internalType: "struct ERC721EqualVestingStream.Config",
        name: "config",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "beneficiary",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketTokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "claimToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "releasedAmount",
        type: "uint256",
      },
    ],
    name: "Claim",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "beneficiary",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ticketTokenIds",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "address",
        name: "claimToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "releasedAmount",
        type: "uint256",
      },
    ],
    name: "ClaimMany",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [],
    name: "WithdrawPowerRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address[]",
        name: "claimTokens",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
    ],
    name: "Withdrawn",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "ticketTokenId",
        type: "uint256",
      },
    ],
    name: "claim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "ticketTokenIds",
        type: "uint256[]",
      },
    ],
    name: "claim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "ticketTokenId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "claimToken",
        type: "address",
      },
    ],
    name: "claim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "ticketTokenIds",
        type: "uint256[]",
      },
      {
        internalType: "address",
        name: "claimToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "beneficiary",
        type: "address",
      },
    ],
    name: "claim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "claimLockedUntil",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "entitlements",
    outputs: [
      {
        internalType: "uint256",
        name: "totalClaimed",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "lastClaimedAt",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "hasERC721EqualSplitExtension",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "hasERC721LockableClaimExtension",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "hasERC721VestingReleaseExtension",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "ticketToken",
            type: "address",
          },
          {
            internalType: "uint64",
            name: "lockedUntilTimestamp",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "startTimestamp",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "durationSeconds",
            type: "uint64",
          },
          {
            internalType: "uint256",
            name: "totalTickets",
            type: "uint256",
          },
          {
            internalType: "uint64",
            name: "claimLockedUntil",
            type: "uint64",
          },
        ],
        internalType: "struct ERC721EqualVestingStream.Config",
        name: "config",
        type: "tuple",
      },
      {
        internalType: "address",
        name: "deployer",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "newValue",
        type: "uint64",
      },
    ],
    name: "lockUntil",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "lockWithdrawMode",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "lockWithdrawRecipient",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "lockedUntilTimestamp",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "revokeWithdrawPower",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "newValue",
        type: "uint64",
      },
    ],
    name: "setClaimLockedUntil",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newValue",
        type: "uint256",
      },
    ],
    name: "setTotalTickets",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "newValue",
        type: "uint64",
      },
    ],
    name: "setVestingDurationSeconds",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "newValue",
        type: "uint64",
      },
    ],
    name: "setVestingStartTimestamp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum WithdrawMode",
        name: "_withdrawMode",
        type: "uint8",
      },
    ],
    name: "setWithdrawMode",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_withdrawRecipient",
        type: "address",
      },
    ],
    name: "setWithdrawRecipient",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "ticketTokenIds",
        type: "uint256[]",
      },
      {
        internalType: "address",
        name: "claimToken",
        type: "address",
      },
    ],
    name: "streamClaimableAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "ticketTokenId",
        type: "uint256",
      },
    ],
    name: "streamClaimableAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "ticketTokenId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "claimToken",
        type: "address",
      },
    ],
    name: "streamClaimableAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "ticketTokenIds",
        type: "uint256[]",
      },
      {
        internalType: "address",
        name: "claimToken",
        type: "address",
      },
    ],
    name: "streamTotalClaimed",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "streamTotalClaimed",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "ticketTokenIds",
        type: "uint256[]",
      },
    ],
    name: "streamTotalClaimed",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "ticketTokenId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "claimToken",
        type: "address",
      },
    ],
    name: "streamTotalClaimed",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "claimToken",
        type: "address",
      },
    ],
    name: "streamTotalClaimed",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "ticketTokenId",
        type: "uint256",
      },
    ],
    name: "streamTotalClaimed",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "streamTotalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "claimToken",
        type: "address",
      },
    ],
    name: "streamTotalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ticketToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalTickets",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "version",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "vestingDurationSeconds",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "vestingStartTimestamp",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "claimTokens",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawMode",
    outputs: [
      {
        internalType: "enum WithdrawMode",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawModeLocked",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawPowerRevoked",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawRecipient",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawRecipientLocked",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

export class ERC721EqualVestingStream__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    config: {
      ticketToken: string;
      lockedUntilTimestamp: BigNumberish;
      startTimestamp: BigNumberish;
      durationSeconds: BigNumberish;
      totalTickets: BigNumberish;
      claimLockedUntil: BigNumberish;
    },
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ERC721EqualVestingStream> {
    return super.deploy(
      config,
      overrides || {}
    ) as Promise<ERC721EqualVestingStream>;
  }
  getDeployTransaction(
    config: {
      ticketToken: string;
      lockedUntilTimestamp: BigNumberish;
      startTimestamp: BigNumberish;
      durationSeconds: BigNumberish;
      totalTickets: BigNumberish;
      claimLockedUntil: BigNumberish;
    },
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(config, overrides || {});
  }
  attach(address: string): ERC721EqualVestingStream {
    return super.attach(address) as ERC721EqualVestingStream;
  }
  connect(signer: Signer): ERC721EqualVestingStream__factory {
    return super.connect(signer) as ERC721EqualVestingStream__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ERC721EqualVestingStreamInterface {
    return new utils.Interface(_abi) as ERC721EqualVestingStreamInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ERC721EqualVestingStream {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ERC721EqualVestingStream;
  }
}
